import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import DispatchOrdersList from "./components/list";
import { Details } from "./components/details";

const DispatchOrders = () => {
  const Location = useLocation();
  return (
    <>
      <Routes>
        <Route path={`/`} element={<Navigate replace="/" to={`${Location.pathname}/list`} />} ></Route>
        <Route path={"list"} element={<DispatchOrdersList />}></Route>
        <Route path={"detail/:id"} element={<Details />} />
      </Routes>
    </>
  );
};

export default DispatchOrders;
